type Layer = {close:()=>void;eligible:()=>boolean};
const layers: Layer[] = [];
export const hasBackLayer=()=>layers.length>0;
export function registerBackLayer(close:()=>void,eligible:()=>boolean=()=>true) {
 const layer={close,eligible};layers.push(layer);
 return () => { const index=layers.lastIndexOf(layer); if(index>=0)layers.splice(index,1);
  if(!layers.length)setTimeout(()=>window.dispatchEvent(new Event('finflow-return-ready')),0); };
}
export function closeTopLayer(): boolean {
 for(let index=layers.length-1;index>=0;index--){const layer=layers[index];if(layer.eligible()){layer.close();return true;}}
 // Unmigrated app dialogs must not allow Back to expose underlying actions.
 return !!document.querySelector('[role="dialog"][aria-modal="true"]');
}
